<div class="task-date-picker" [class.task-date-picker--open]="isOpen" [class.task-date-picker--disabled]="disabled">
  <!-- Trigger : tag si date sélectionnée, bouton texte sinon -->
  <eva-tag
    *ngIf="date || plannedStartDate"
    [preset]="dateTagPreset"
    size="small"
    [rounded]="true"
    [removable]="showClear"
    tabindex="0"
    role="button"
    aria-label="Modifier la date"
    (click)="toggle()"
    (keydown)="onTagKeyDown($event)"
    (onRemove)="clear()"
  ></eva-tag>
  <eva-button
    *ngIf="!(date || plannedStartDate)"
    icon="heroCalendar"
    [label]="placeholder"
    variant="text"
    size="small"
    (onClick)="toggle()"
    [disabled]="disabled"
  ></eva-button>

  <!-- Popover calendrier -->
  <div class="task-date-picker__popover" *ngIf="isOpen">
    <!-- Calendrier ouvert d'emblée, en échéance ; « Date de fin » passe en période (comme Notion) -->
    <ng-container>
      <!-- Saisie clavier : 02.11.2026, 02112026, 021126, 0211 -->
      <div class="task-date-picker__typed">
        <eva-input
          size="small"
          placeholder="JJ.MM.AAAA"
          [value]="typedDate"
          [error]="typedDateError"
          (valueChange)="onTypedDateChange($event)"
          (keydown.enter)="applyTypedDate($event)"
        ></eva-input>
      </div>

      <!-- Hint pour le mode range -->
      <div *ngIf="dateMode === 'range'" class="task-date-picker__range-hint">
        {{ rangeStep === "start" ? "Sélectionner la date de début" : "Sélectionner la date de fin" }}
      </div>

      <!-- Raccourcis rapides (seulement en mode deadline) -->
      <div class="task-date-picker__shortcuts" *ngIf="dateMode === 'deadline'">
        <button type="button" (click)="selectToday()">
          <ng-icon name="evaCalendarPlus"></ng-icon>
          Aujourd'hui
        </button>
        <button type="button" (click)="selectTomorrow()">
          <ng-icon name="heroArrowRight"></ng-icon>
          Demain
        </button>
        <button type="button" (click)="selectNextWeek()">
          <ng-icon name="heroCalendar"></ng-icon>
          Semaine pro.
        </button>
      </div>

      <!-- Séparateur (seulement en mode deadline) -->
      <div class="task-date-picker__divider" *ngIf="dateMode === 'deadline'"></div>

      <!-- Navigation mois -->
      <div class="task-date-picker__nav">
        <button type="button" class="task-date-picker__nav-btn" (click)="prevMonth()">
          <ng-icon name="heroChevronLeft"></ng-icon>
        </button>
        <span class="task-date-picker__month-label">{{ monthLabel }}</span>
        <button type="button" class="task-date-picker__nav-btn" (click)="nextMonth()">
          <ng-icon name="heroChevronRight"></ng-icon>
        </button>
      </div>

      <!-- Jours de la semaine -->
      <div class="task-date-picker__weekdays">
        <span *ngFor="let day of weekDays">{{ day }}</span>
      </div>

      <!-- Grille calendrier -->
      <div class="task-date-picker__grid">
        <button
          *ngFor="let day of calendarDays"
          type="button"
          class="task-date-picker__day"
          [class.task-date-picker__day--other-month]="!day.isCurrentMonth"
          [class.task-date-picker__day--today]="day.isToday"
          [class.task-date-picker__day--selected]="day.isSelected"
          [class.task-date-picker__day--disabled]="day.isDisabled"
          [class.task-date-picker__day--start]="day.isStart"
          [class.task-date-picker__day--end]="day.isEnd"
          [class.task-date-picker__day--in-range]="day.isInRange"
          [disabled]="day.isDisabled"
          (click)="selectCalendarDay(day)"
        >
          {{ day.day }}
        </button>
      </div>

      <div class="task-date-picker__footer">
        <eva-switch
          label="Date de fin"
          labelPosition="before"
          size="small"
          class="task-date-picker__end-switch"
          [checked]="dateMode === 'range'"
          (checkedChange)="onEndDateToggle($event)"
        ></eva-switch>
        <button
          *ngIf="date || plannedStartDate"
          type="button"
          class="task-date-picker__clear-btn"
          (click)="clear($event)"
        >
          <ng-icon name="heroXMark"></ng-icon>
          Effacer
        </button>
      </div>
    </ng-container>
  </div>
</div>
